import moment from 'moment-timezone';
import store from '@adobe/edex/frontend/store';
import constants from '@adobe/edex/frontend/mixins/constants';

// Localizes date/time. Expects backend to return date/time in yyyy-mm-dd hh:mm:ss format
export function lzDateFmt(value, format = 'll', addZoneAbbr = false) {
  let newFormat = moment.utc(value).local().format(format); // format date

  // Append time zone abbreviation?
  if (addZoneAbbr) {
    const zoneAbbr = moment.tz(moment.tz.guess()).format('z');
    newFormat += ' ' + zoneAbbr;
  }

  return newFormat;
}

export const getCurrentLanguage = () =>
  document.documentElement.lang.includes('-')
    ? document.documentElement.lang.substr(0, document.documentElement.lang.indexOf('-')).toLowerCase()
    : document.documentElement.lang;

export function buildLink(link, locale = store.state.config.locale) {
  return `${locale && locale !== 'en' ? `/${locale}` : ''}${link}`;
}

// Decorates the route, primarily used for adding the current locale
export function rDecor(route) {
  route.params = route.params || {};
  if (!route.params[constants.localeParam]) {
    const locale = store.state.config.locale;
    if (locale !== 'en') {
      route.params[constants.localeParam] = locale;
    }
  }
  return route;
}

export function getStaticPageIDs(pageName) {
  const locale = store.state.config.locale;
  if (pageName === 'horizontalCTA') {
    if (locale === 'de') {
      return ['ce821c6c-0b64-482f-b873-2760f22fd6de'];
    }
    if (locale === 'jp') {
      return ['02a684bc-a19a-11e8-92dd-1243aee7e8f7'];
    }
    return ['ce821c6c-0b64-482f-b873-2760f22fd61a']; // EN
  }
  if (pageName === 'landingBanner') {
    if (locale === 'de') {
      return ['9a8ccf02-6bfa-4302-88c0-a58d8371b9de'];
    }
    if (locale === 'jp') {
      return ['02a68524-a19a-11e8-92dd-1243aee7e8f7'];
    }
    return ['9a8ccf02-6bfa-4302-88c0-a58d8371b9cc']; // EN
  }
  if (pageName === 'pdCoursesLandingBanner') {
    return ['8f7a883b-b79e-4352-8392-93cd68da406f']; // EN
  }
  if (pageName === 'landingSlides') {
    if (locale === 'de') {
      return [
        '82920f36-7e18-4685-bc67-2eefb61fb7de',
        '4d04f30b-79f0-4f26-964d-d681d37b7ade',
        'b55ba164-ccd0-4b0d-a1a5-f4ec6a68b5de',
      ];
    }
    if (locale === 'jp') {
      return [
        '02a68577-a19a-11e8-92dd-1243aee7e8f7',
        '02a685bf-a19a-11e8-92dd-1243aee7e8f7',
        '02a6860b-a19a-11e8-92dd-1243aee7e8f7',
      ];
    }
    return [
      '82920f36-7e18-4685-bc67-2eefb61fb7df',
      '4d04f30b-79f0-4f26-964d-d681d37b7a11',
      'b55ba164-ccd0-4b0d-a1a5-f4ec6a68b51e',
    ]; // EN
  }

  return [];
}
